var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',_vm._b({class:{'invert': !_setup.icon.startsWith('mdi-')},attrs:{"large":""}},'v-icon',_vm.$attrs,false),[_vm._v(" "+_vm._s(_setup.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }